import {css} from 'styled-components'

export const containerMixin = (width = '1200px') => css`
  margin-right: auto;
  margin-left: auto;
  max-width: ${width};
`
